module.exports = __webpack_public_path__ + "static/media/img-explore.0292e51b.svg";